import React from 'react';
import './PrivateProfile.scss';
import { BuyerUploads } from '../BuyerUploads/BuyerUploads';
import { MarketplaceBuyerUploadAccessLevel } from '../../../../../slices/marketplace/buyer/models/buyer-upload';
import { Button, CardHeader } from 'reactstrap';

export interface PrivateProfileProps {
    setIsEditMode: (isEditMode: boolean) => void;
}

export const PrivateProfile = (props: PrivateProfileProps) => {
    return (
        <div className="private-profile">
            <CardHeader className="private-profile-header space-between">
                Private Documents
                <div className="buttons-wrapper">
                    <Button
                        className="btn btn-primary"
                        onClick={() => {
                            props.setIsEditMode(false);
                        }}>
                        Back
                    </Button>
                </div>
            </CardHeader>
            <BuyerUploads
                accessLevel={
                    MarketplaceBuyerUploadAccessLevel.Private
                }></BuyerUploads>
        </div>
    );
};
